import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline, Box } from '@mui/material';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedLayout from './components/ProtectedLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';
import Users from './pages/Users';
import Responsibles from './pages/Responsibles';
import ResponsibleDetails from './pages/ResponsibleDetails';
import FeasibilityAnalysis from './pages/FeasibilityAnalysis';
import Profile from './pages/Profile';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  const isAdmin = role === '1';
  const isTechnical = role === '3';
  const hasAccess = adminOnly ? (isAdmin || isTechnical) : true;

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && !hasAccess) {
    return <Navigate to="/dashboard" />;
  }

  return <ProtectedLayout>{children}</ProtectedLayout>;
};

function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/projects" element={
            <ProtectedRoute>
              <Projects />
            </ProtectedRoute>
          } />
          
          <Route path="/projects/:id" element={
            <ProtectedRoute>
              <ProjectDetails />
            </ProtectedRoute>
          } />
          
          <Route path="/users" element={
            <ProtectedRoute adminOnly>
              <Users />
            </ProtectedRoute>
          } />
          
          <Route path="/responsibles" element={
            <ProtectedRoute adminOnly>
              <Responsibles />
            </ProtectedRoute>
          } />
          
          <Route path="/responsibles/:id" element={
            <ProtectedRoute adminOnly>
              <ResponsibleDetails />
            </ProtectedRoute>
          } />
          
          <Route path="/feasibility" element={
            <ProtectedRoute adminOnly>
              <FeasibilityAnalysis />
            </ProtectedRoute>
          } />
          
          <Route path="/profile" element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } />
          
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
